import { BeakerIcon } from "@heroicons/react/outline";
import { XIcon } from "@heroicons/react/solid";
import { RocketIcon } from "@radix-ui/react-icons";
import classNames from "classnames";
import React from "react";

interface ReleaseLabelProps {
  label: {
    id: number;
    name: string;
  };
  isActiveVersion?: boolean;
  onDelete?: (label: { id: number; name: string }) => void;
  isDragging?: boolean;
}

export const getEnvFlair = (name: string) => {
  switch (name.toLowerCase()) {
    case "prod":
    case "production":
      return <RocketIcon className="inline-block h-3 w-3 align-middle" />;
    case "staging":
    case "dev":
    case "development":
      return <BeakerIcon className="inline-block h-3 w-3 align-middle" />;
    default:
      return null;
  }
};

const ReleaseLabel: React.FC<ReleaseLabelProps> = ({
  label,
  isActiveVersion = false,
  onDelete,
  isDragging = false,
}) => {
  const envFlair = getEnvFlair(label.name);
  const isReadOnly = !onDelete;

  return (
    <div
      key={`${label.name}-${label.id}`}
      className={classNames(
        "group/Label relative flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium transition-all duration-150 ease-in-out",
        envFlair
          ? "border-blue-800 bg-blue-700 text-white"
          : "border-gray-400 bg-white text-black",
        !isReadOnly &&
          "hover:border-red-400 hover:bg-red-50 hover:text-red-600 hover:shadow-sm",
        isDragging && "opacity-85 shadow-md",
      )}
      onClick={(e) => {
        if (isReadOnly) return;
        e.preventDefault();
        e.stopPropagation();
        onDelete?.(label);
      }}
    >
      {envFlair && <span className="mr-1 flex items-center">{envFlair}</span>}
      <span className="align-middle">{label.name}</span>
      {!isReadOnly && (
        <div
          className="absolute -right-1.5 -top-1.5"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete?.(label);
          }}
        >
          <XIcon
            className={`invisible h-3 w-3 cursor-pointer rounded-full text-red-500 ${
              isActiveVersion ? "bg-blue-100 " : "bg-white"
            } transition-opacity group-hover/Label:visible`}
          />
        </div>
      )}
    </div>
  );
};

export default ReleaseLabel;
